const points = [
  {
    icon: 'ri-team-line',
    title: 'A cuantas personas puedo registrar?',
    text: 'Cada plan indica cuantas personas pueden quedar registradas. Basico permite titular + 2 familiares directos. Prime permite titular + 3 familiares directos.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Quien puede quedar registrado?',
    text: 'Solo familia directa verificada con CURP: conyuge o pareja, hijos, padres y hermanos del titular. Otros parentescos pueden requerir revision previa.',
  },
  {
    icon: 'ri-time-line',
    title: 'Que pasa con la carencia?',
    text: 'Puede existir un periodo de 90 dias desde el primer pago. Cada familiar registrado despues puede tener su propio periodo de carencia desde su fecha de alta.',
  },
];

export default function PricingDisclaimer() {
  return (
    <section className="bg-[#0A0A0A] py-14 md:py-20 px-4">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-title text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 md:mb-4">
            Lo que debes saber antes de contratar
          </h2>
          <p className="text-white/45 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Transparencia desde el primer dia: servicios sujetos a contrato, periodo de carencia, elegibilidad y disponibilidad de la red aliada.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {points.map((point) => (
            <div
              key={point.title}
              className="reveal rounded-xl p-5 md:p-7 flex flex-col gap-3 md:gap-4"
              style={{ background: '#141414', border: '1px solid rgba(83,74,183,0.35)' }}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#534AB7]/20">
                <i className={`${point.icon} text-[#7F77DD] text-lg`}></i>
              </div>
              <h3 className="font-title text-white text-base font-bold leading-snug">
                {point.title}
              </h3>
              <p className="text-white/50 text-sm leading-relaxed">
                {point.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
